import { render, staticRenderFns } from "./YouthView.vue?vue&type=template&id=87dcae46"
import script from "./YouthView.vue?vue&type=script&lang=js"
export * from "./YouthView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports